var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import { StringifyingMap } from '@flexem/fc-gui';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { DataSourceIdentifier } from '../../../core/data-source/data-source-identifier';
import { ChannelModel } from './channel.model';
import { PreChannelKey } from './pre-channel-key.model';
var HistoryCurveChannelSettingComponent = /** @class */ (function (_super) {
    __extends(HistoryCurveChannelSettingComponent, _super);
    function HistoryCurveChannelSettingComponent(injector, historyDataService) {
        var _this = _super.call(this, injector) || this;
        _this.historyDataService = historyDataService;
        _this.lineColors = ['#4d95f7', '#0ac14b', '#ffa800', '#ff4448', '#c444ff', '#6344ff', '#00e8ae', '#92d600',
            '#ff6600', '#ff00cc', '#a200dc', '#2fccff', '#5f8bef', '#67e192', '#f0c065', '#ff7073'];
        _this.channels = [];
        _this.preChannels = new StringifyingMap(function (k) { return JSON.stringify(k); });
        return _this;
    }
    Object.defineProperty(HistoryCurveChannelSettingComponent.prototype, "currentDataSourceId", {
        get: function () {
            return this._currentDataSourceId;
        },
        set: function (v) {
            if (DataSourceIdentifier.equals(this._currentDataSourceId, v)) {
                return;
            }
            this.setChannelsData();
            this._currentDataSourceId = v;
            this.data.dataSourceCode = v.code;
            this.getHistoryDataNames();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveChannelSettingComponent.prototype, "selectHistoryDataName", {
        get: function () {
            return this._historyDataName;
        },
        set: function (v) {
            if (_.isEqual(this._historyDataName, v)) {
                return;
            }
            this._historyDataName = v;
            if (v) {
                this.setChannelsData();
                this.data.historyDataName = v.name;
                this.getHistoryDataChannels();
            }
            else {
                this.data.historyDataName = undefined;
                this.channels = [];
                this.data.channelsData = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    HistoryCurveChannelSettingComponent.prototype.ngOnInit = function () {
        this.data.channelsData = this.data.channelsData || [];
        this.initData();
    };
    HistoryCurveChannelSettingComponent.prototype.validate = function () {
        if (!this.data.historyDataName) {
            this.message.error(this.lc('HistoryDataNameRequired'));
            return false;
        }
        if (this.data.channelsData.length === 0) {
            this.message.error(this.lc('ChannelRequired'));
            return false;
        }
        return true;
    };
    HistoryCurveChannelSettingComponent.prototype.getHistoryDataNames = function () {
        var _this = this;
        this.channels = [];
        this.loading = true;
        this.historyDataService.getHistoryDataNames(this.configureId, this.currentDataSourceId.code)
            .pipe(finalize(function () { return _this.loading = false; }))
            .subscribe(function (response) {
            _this.historyDataNames = response.items;
            if (_this.historyDataNames && _this.historyDataNames.length > 0) {
                if (_this.data.historyDataName !== undefined && _this.data.historyDataName !== '') {
                    var historyDataName = _.find(_this.historyDataNames, function (h) { return h.name === _this.data.historyDataName; });
                    if (historyDataName) {
                        _this.selectHistoryDataName = historyDataName;
                    }
                }
            }
            else {
                _this.selectHistoryDataName = undefined;
            }
        });
    };
    HistoryCurveChannelSettingComponent.prototype.getHistoryDataChannels = function () {
        var _this = this;
        if (!this.selectHistoryDataName.id) {
            return;
        }
        abp.ui.setBusy();
        this.historyDataService.getHistoryDataChannels(this.selectHistoryDataName.id)
            .pipe(finalize(function () { return abp.ui.clearBusy(); }))
            .subscribe(function (response) {
            var channelsData = [];
            var historyDataChannels = response.items;
            historyDataChannels.forEach(function (x, i) {
                channelsData.push({
                    isEnabled: false, channelName: x.channelName,
                    lineColor: _this.lineColors[i], projectionColor: false
                });
            });
            _this.data.channelsData = [];
            var preChannelsData = _this.getChannelsData(new PreChannelKey(_this.currentDataSourceId.code, _this.selectHistoryDataName.name));
            preChannelsData.forEach(function (preChannelData) {
                var channelData = _.filter(channelsData, { channelName: preChannelData.channelName });
                if (channelData && channelData.length > 0) {
                    _this.data.channelsData.push(preChannelData);
                }
            });
            _this.channels = _.map(channelsData, function (channel) {
                var seletedChannel = _this.data.channelsData.find(function (r) { return r.channelName === channel.channelName; });
                var channelData = new ChannelModel(_this.data.channelsData, seletedChannel);
                channelData.isEnabled = !!seletedChannel;
                channelData.channelName = channel.channelName;
                channelData.lineColor = seletedChannel ? seletedChannel.lineColor : channel.lineColor;
                channelData.projectionColor = seletedChannel ? seletedChannel.projectionColor : channel.projectionColor;
                return channelData;
            });
        });
    };
    HistoryCurveChannelSettingComponent.prototype.getChannelsData = function (preChannelKey) {
        if (!this.preChannels.has(preChannelKey)) {
            this.preChannels.set(preChannelKey, this.data.channelsData);
        }
        return this.preChannels.get(preChannelKey);
    };
    HistoryCurveChannelSettingComponent.prototype.setChannelsData = function () {
        if (this.data.channelsData && this.data.channelsData.length > 0 && this._historyDataName) {
            this.preChannels.set(new PreChannelKey(this.currentDataSourceId.code, this._historyDataName.name), this.data.channelsData);
            this.data.channelsData = [];
        }
    };
    HistoryCurveChannelSettingComponent.prototype.initData = function () {
        var data = this.data;
        this._currentDataSourceId = DataSourceIdentifier.tryParse(data.dataSourceCode);
        this.getHistoryDataNames();
    };
    HistoryCurveChannelSettingComponent.prototype.setLineColor = function (color, index) {
        this.channels[index].lineColor = color;
    };
    __decorate([
        Input()
    ], HistoryCurveChannelSettingComponent.prototype, "data", void 0);
    __decorate([
        Input()
    ], HistoryCurveChannelSettingComponent.prototype, "configureId", void 0);
    HistoryCurveChannelSettingComponent = __decorate([
        Component({
            selector: 'history-curve-channel',
            styles: [".history-table{ border:none; table{ width:100%; border: 1px solid #d7dbe5; tbody { max-height:128px; overflow-y: auto; tr { td{ text-align: center; vertical-align:middle; padding: 3px; color:#666; border-top: 1px solid #d7dbe5; .color-picker{ width: 80px; height: 26px; } } } } thead { tr { background-color: #f2f3f8; th{ text-align: center; vertical-align:middle; font-weight: normal; color:#333333; font-size: 15px; padding: 6px; } } } } .line-color-div{ width:100%; height:26px; justify-content:center; align-items:center; display:-webkit-flex } } "],
            template: "<div class=\"fe-modal-content\"> <div class=\"fe-vertical-label\"> <label class=\"fe-vertical-title\">{{lc(\"DataSource\")}}:</label> <div class=\"fe-vertical-component\"> <data-source-combo [(selectedDataSourceId)]=\"currentDataSourceId\"></data-source-combo> </div> </div> <div class=\"fe-vertical-label\"> <label class=\"fe-vertical-title\">{{lc(\"HistoryDataName\")}}:</label> <div class=\"fe-vertical-component\"> <ng-select [items]=\"historyDataNames\" bindLabel=\"name\" [(ngModel)]=\"selectHistoryDataName\" [clearable]=\"false\" [placeholder]=\"lc('SelectHistoryDataName')\" [loading]=\"loading\" [loadingText]=\"l('LoadWithThreeDot')\" [notFoundText]=\"l('NoData')\"> <ng-template ng-label-tmp let-item=\"item\"> {{item.name}} </ng-template> </ng-select> </div> </div> <div class=\"history-table margin-top-10\"> <table> <thead> <tr> <th width=\"10%\">{{l(\"On\")}}</th> <th width=\"30%\">{{lc(\"ChannelName\")}}</th> <th width=\"30%\">{{lc(\"LineColor\")}}</th> <th width=\"30%\">{{lc(\"ProjectionColor\")}}</th> </tr> </thead> <tbody> <tr *ngFor=\"let channel of channels;index as i;\"> <td width=\"10%\"> <label> <input type=\"checkBox\" [(ngModel)]=\"channel.isEnabled\" name=\"isEnabled\" /> </label> </td> <td width=\"30%\">{{channel.channelName}}</td> <td width=\"30%\" align=\"center\"> <div class=\"line-color-div\"> <div class=\"color-picker design-color-picker\"> <color-picker [color]=\"channel.lineColor\"  (sentColor)=\"setLineColor($event , i)\" [disabled]=\"!channel.isEnabled\"></color-picker> </div> </div> </td> <td width=\"30%\"> <div> <ui-switch [(ngModel)]=\"channel.projectionColor\" color=\"#3695ff\" size=\"small\" [disabled]=\"!channel.isEnabled\"></ui-switch> </div> </td> </tr> </tbody> </table> </div> </div> "
        })
    ], HistoryCurveChannelSettingComponent);
    return HistoryCurveChannelSettingComponent;
}(ConfigureComponentBase));
export { HistoryCurveChannelSettingComponent };
